import { render, staticRenderFns } from "./PagePreview.vue?vue&type=template&id=af749c1e&"
import script from "./PagePreview.vue?vue&type=script&lang=js&"
export * from "./PagePreview.vue?vue&type=script&lang=js&"
import style0 from "./PagePreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports